import { render, staticRenderFns } from "./PreviewVideoCard.vue?vue&type=template&id=200f852e&"
import script from "./PreviewVideoCard.vue?vue&type=script&lang=js&"
export * from "./PreviewVideoCard.vue?vue&type=script&lang=js&"
import style0 from "./PreviewVideoCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports